import React from 'react';

import { PropsWithChildren } from 'react';
import { Box, useTheme } from '@mui/material';
import { mainFooterHeight } from '../../common/MetaSetting';

export const Footer = ({ children }: PropsWithChildren<unknown>) => {
  const theme = useTheme();

  if (!children) {
    return null;
  }

  return (
    <Box
      sx={{
        flexGrow: 0,
        height: mainFooterHeight,
        // 对齐 memo-flutter 底栏:surface 背景 + onSurfaceVariant 文字
        background: theme.palette.background.paper,
        color: 'text.secondary',
        textAlign: 'center'
      }}
      className="copyright"
    >
      {children}
    </Box>
  );
};
